module.exports = __webpack_public_path__ + "static/media/icon-savings.38ca1211.svg";